<template>
  <div class="wrap talk">
    <header>
      <h1><a href="#" class="logo"></a></h1>
    </header>
    <div class="container">
      <main class="content">
        <article class="certification">
          <section
            class="txt agree-bg"></section>
          <section>
            <div class="box row row_c row_jsc">
              <span><i class="xi-check"></i></span>
              <h2>픽업 신청 완료</h2>
              <br/>
              <p>픽업 신청이 완료되어</p>
              <p>기사님이 배송 키트를 픽업할 예정이에요!</p>
              <br/>
              <p>검수센터 도착 후 1일 이내</p>
              <h4>중고폰의 판매금액을 알림톡으로 안내드릴게요</h4>
              <br/>
              <br/>
            </div>
          </section>
        </article>
        <div class="cs-center row row_ac row_jsc">
          <span class="qa">고객센터 문의 </span>
          <span><a href="tel:1877-5446" class="en phone">1877-5446</a></span>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'

export default {
  name: 'VisitMintitComplete',
  components: {},
  data: () => ({
    isChecked: false
  }),
  computed: {},
  mounted () {},
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/views/purchase/home/VisitMintitComplete.vue